export default [
  {
    path: '/admin/defines/taxes',
    name: 'Taxes',
    component: () => import('@/views/Admin/Defines/Taxes/Index.vue'),
    meta: {
      pageTitle: 'Vergi Oranları',
      breadcrumb: [
        {
          text: 'Liste',
          active: true,
        },
      ],
      resource: 'ADMIN_DEFINES_ALL',
      action: 'read',
    },
  },
  {
    path: '/admin/defines/taxes/add',
    name: 'TaxAdd',
    component: () => import('@/views/Admin/Defines/Taxes/Add.vue'),
    meta: {
      pageTitle: 'Vergi Oranları',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/admin/defines/taxes',
          active: false,
        },
        {
          text: 'Oluştur',
          active: true,
        },
      ],
      resource: 'ADMIN_DEFINES_ALL',
      action: 'read',
    },
  },
  {
    path: '/admin/defines/taxes/edit/:id',
    name: 'TaxEdit',
    component: () => import('@/views/Admin/Defines/Taxes/Edit.vue'),
    meta: {
      pageTitle: 'Vergi Oranları',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/admin/defines/taxes',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
      resource: 'ADMIN_DEFINES_ALL',
      action: 'read',
    },
  },
]
